import { RenderWithBuilder } from "@faire/builder-core/BuilderComponents/RenderWithBuilder";
import { RenderWithBuilderProps } from "@faire/builder-core/BuilderComponents/types";
import React from "react";

import { registerRetailerComponents } from "./__internal__/registerRetailerComponents";

export const RetailerRenderWithBuilder: React.FC<RenderWithBuilderProps> = (
  props
) => {
  return (
    <RenderWithBuilder
      {...props}
      registerCustomComponents={registerRetailerComponents}
    />
  );
};
